// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ChangeVcsRoots__wrapper--h0","currentVcsRoot":"ChangeVcsRoots__currentVcsRoot--iO"};